import { DatasyncClient, TransportAdapter } from '@ps-int/datasync-client';
import { Api } from '@ps-int/transport';

import getCloudAPIUrl from './get-cloud-api-url';
import { createLogger } from './loggerFacade';

const logger = createLogger('datasync');

const datasyncClients: Record<string, DatasyncClient> = {};

type DataSyncOptions = { db: string; collection: string; userUid?: string };

export const getDatasyncClient = ({ db, collection, userUid }: DataSyncOptions) => {
    if (!datasyncClients[db]) {
        const transport = new TransportAdapter({
            transport: new Api(getCloudAPIUrl(), {
                getAdditionalHeaders: () => ({ 'X-Borigin': 'telemost' }),
            }),
            uid: userUid ?? '',
            db: db,
            collection: collection,
        });
        datasyncClients[db] = new DatasyncClient({
            transport,
            errorHandler: (error) => {
                logger.error(error, {
                    method: 'DatasyncClient errorHandler',
                    block: 'settings',
                    type: 'datasyncClientInitError',
                });
            },
        });
    }

    return datasyncClients[db];
};
